import { type VariablesOf } from '@graphql-typed-document-node/core'
import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'

import { useDocumentReportId } from './useDocumentReportId'

const document = graphql(`
  mutation DocumentReportEditPage_UpdateDocumentReport(
    $documentReportId: ID!
    $content: String
    $title: String
  ) {
    updateDocument(
      documentId: $documentReportId
      content: $content
      title: $title
    ) {
      ok
    }
  }
`)
type Variables = VariablesOf<typeof document>

export const useUpdateDocumentReportMutation = (
  options: MutationOptions<void, Omit<Variables, 'documentReportId'>> = {},
) => {
  const graphQLRequest = useGraphQLRequest()
  const documentReportId = useDocumentReportId()
  const { t } = useTranslation()

  return useMutation({
    mutationFn: async (variables) => {
      const result = await graphQLRequest({
        document,
        variables: { documentReportId, ...variables },
      })

      const ok = result.updateDocument?.ok ?? false
      if (!ok) {
        throw new Error(t('update_failed'))
      }
    },
    ...options,
  })
}
